import { ThemeAccessor } from "./themeAccessor";
import { createContext, useContext } from "react";
export const ThemeContext = /*#__PURE__*/createContext({});
export function useThemeContext() {
  const {
    theme,
    ...rest
  } = useContext(ThemeContext);
  return { ...rest,
    theme,
    themeAccessor: new ThemeAccessor(theme)
  };
}